import { useState } from 'react';
import { useParams } from 'react-router';
import { defaultTranslations } from '../translations';
import { DEFAULT_LOCALE } from '../translations/defaultLocale';
import type { Locale } from '../types';

function isValidLocale(locale: string): locale is Locale {
  return locale in defaultTranslations;
}

export default function useLanguage() {
  const { locale = DEFAULT_LOCALE } = useParams();

  const [language, setLanguage] = useState(isValidLocale(locale) ? locale : DEFAULT_LOCALE);
  const [prevLocale, setPrevLocale] = useState(locale);

  if (locale !== prevLocale) {
    setPrevLocale(locale);
    setLanguage(isValidLocale(locale) ? locale : DEFAULT_LOCALE);
  }

  return language;
}
